import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TopProgress from "./components/TopProgress";
import WhatsAppButton from "./components/WhatsAppButton";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import About from "./pages/About";
import Applications from "./pages/Applications";
import ApplicationDetail from "./pages/ApplicationDetail";
import References from "./pages/References";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Contact from "./pages/Contact";
import Quote from "./pages/Quote";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-white">
      <BrowserRouter>
        <ScrollToTop />
        <TopProgress />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/kurumsal" element={<About />} />
            <Route path="/uygulamalar" element={<Applications />} />
            <Route path="/uygulama/:slug" element={<ApplicationDetail />} />
            <Route path="/referanslar" element={<References />} />
            <Route path="/haberler" element={<News />} />
            <Route path="/haber/:slug" element={<NewsDetail />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/teklif-iste" element={<Quote />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
